export default "__VITE_ASSET__c99ebe3b__"